export class hijos {
    public id: number;
    public nombre: string;
    public asignadoExclusivo: any;
}